import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import InvoiceCreditMemoContainer from '../../containers/accounting/InvoiceCreditMemo';
import StationInvoiceForPdf from '../../components/StationInvoiceForPdf';

const styles = () => {
	return {
		root: {
			position: 'absolute',
			backgroundColor: 'white',
			height: '100%',
			width: '100%',
		},
	};
};

//- The credit memo renders with the invoice PDF layout in credit memo mode: the original
//- invoice's station/addresses/terms with the credit memo's line items negated.
class StationCreditMemo extends Component {
	constructor(props) {
		super(props);
		const invoiceCreditMemoId = _.get(this.props, ['match', 'params', 'invoiceCreditMemoId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			invoiceCreditMemoId: invoiceCreditMemoId ? parseInt(invoiceCreditMemoId, 10) : undefined,
			securityHash,
			errors: [],
		};
	}

	componentDidMount() {
		const { publicGetInvoiceCreditMemo } = this.props;
		const { invoiceCreditMemoId, securityHash } = this.state;

		publicGetInvoiceCreditMemo({
			params: {
				invoiceCreditMemoId,
				securityHash,
			},
			callback: (err, r) => {
				if (err) {
					return this.setState({ errors: [err] });
				}
				const collections = _.get(r, ['collections'], {});
				const creditMemo = _.get(collections, ['invoiceCreditMemoCollection', 0]);
				if (!creditMemo) {
					return this.setState({ errors: ['Missing credit memo.'] });
				}

				const stationInvoiceMap = _.keyBy(
					collections.stationInvoiceCollection,
					'stationInvoiceId'
				);
				const originalInvoice = stationInvoiceMap[creditMemo.originalInvoiceId];
				if (!originalInvoice) {
					return this.setState({ errors: ['Missing original invoice.'] });
				}

				return this.setState({
					creditMemo,
					originalInvoice,
					stationMap: _.keyBy(collections.stationCollection, 'stationId'),
					quickbooksCustomerMap: _.keyBy(
						collections.quickbooksCustomerCollection,
						'quickbooksCustomerId'
					),
					quickbooksTermMap: _.keyBy(collections.quickbooksTermCollection, 'quickbooksTermId'),
				});
			},
		});
	}

	render() {
		const { classes } = this.props;
		const {
			errors,
			creditMemo,
			originalInvoice,
			stationMap,
			quickbooksCustomerMap,
			quickbooksTermMap,
		} = this.state;

		if (errors.length) {
			return (
				<div>
					<div>Encountered an error when retrieving the credit memo</div>
					{errors.map((error, i) => {
						return <div key={i}>{error}</div>;
					})}
				</div>
			);
		}

		if (!creditMemo) {
			return <div>Fetching credit memo...</div>;
		}

		//- The PDF layout reads invoice fields; swap in the credit memo's date and lines
		const invoiceForPdf = _.assign({}, originalInvoice, {
			issueDate: creditMemo.issueDate,
			lineItems: creditMemo.lineItems,
		});

		return (
			<div className={classes.root}>
				<StationInvoiceForPdf
					stationInvoice={invoiceForPdf}
					quickbooksCustomerMap={quickbooksCustomerMap}
					quickbooksTermMap={quickbooksTermMap}
					stationMap={stationMap}
					isCreditMemo={true}
					creditMemoId={creditMemo.invoiceCreditMemoId}
					originalInvoiceId={creditMemo.originalInvoiceId}
				/>
			</div>
		);
	}
}

StationCreditMemo.propTypes = {
	classes: PropTypes.object.isRequired,
	publicGetInvoiceCreditMemo: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), InvoiceCreditMemoContainer])(StationCreditMemo);
